/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { MARK_OFFER_AVAILABLE, MARK_OFFER_PROVIDED, REMOVE_OFFER_DATA, SAVE_OFFER_DATA } from '../actions/actionTypes';
import objectPath from 'object-path';
import { OfferData } from '../../../types/offer-data';

function addItemToArray(stringArray: string[], item: string): string[]{
    if(stringArray === undefined){
        stringArray = [item];
    }
    else if(!stringArray.includes(item)){
        stringArray.push(item);
    }

    return stringArray;
}
export default function offerReducer(state = {}, action: any): {} {
    let newState;
    switch (action.type) {
        case MARK_OFFER_AVAILABLE: {
            newState = Object.assign({}, state);

            //@ts-ignore
            let offersAvailable = newState.OffersAvailable;

            offersAvailable = addItemToArray(offersAvailable, action.offer);

            objectPath.set(newState, "OffersAvailable", offersAvailable);

            return newState;
        }
        case MARK_OFFER_PROVIDED: {
            newState = Object.assign({}, state);
            //@ts-ignore
            let offersProvided = newState.OffersProvided;

            offersProvided = addItemToArray(offersProvided, action.offer);
            
            objectPath.set(newState, "OffersProvided", offersProvided);

            return newState;
        }
        case SAVE_OFFER_DATA: {
            newState = Object.assign({}, state);
            
            //@ts-ignore
            const offersData = newState.OfferData;

            const objIndex = offersData.findIndex(((obj: OfferData) => obj.OfferType == action.offer));

            if(objIndex === -1){
                offersData.push({
                    OfferType: action.offer,
                    Data: action.data,
                });
            }
            else{
                offersData[objIndex].Data = action.data;
            }

            objectPath.set(newState, "OfferData", offersData);
            return newState;
        }

        case REMOVE_OFFER_DATA: {
            newState = Object.assign({}, state);
            //@ts-ignore
            const offersData = newState.OfferData;

            const objIndex = offersData.findIndex(((obj: OfferData) => obj.OfferType == action.offerName));

            if(objIndex > -1){
                offersData.splice(objIndex, 1);
            }

            objectPath.set(newState, "OfferData", offersData);

            return newState;
        }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./modules/launch-offers-post-message-handling/reducers/offerReducer.ts